import { get, patch, post } from './requests'

export const getLaborTypes = key => params =>
  get(['labor_types'], { key, transformPayload: true, params })

export const getLaborTypeById = key => laborTypeId =>
  get(['labor_types', laborTypeId], { key, transformPayload: true })

export const postLaborType = key => payload =>
  post(['labor_types'], { key, transformPayload: true }, payload)

export const patchLaborType = key => (laborTypeId, payload) =>
  patch(['labor_types', laborTypeId], { key, transformPayload: true }, payload)
